import React from 'react';
import { loader_overlay } from './mask.module.scss';

export const Mask = () => (
  <div className="loader">
    <div className={loader_overlay} />
  </div>
);
